import React from 'react'
import { t } from 'ttag'
import styles from './HideExtensiveText.module.scss'

export const HideExtensiveText = ({
  text,
  length = 100,
  showReadLess = true,
}) => {
  const [isHidden, setIsHidden] = React.useState(true)

  const initText = text.substr(0, length)
  const revealedText = text.substr(length)

  if (!revealedText) {
    return <span>{initText}</span>
  }

  return (
    <p className={styles.readMore}>
      <span>{isHidden ? `${initText.trim()}...` : initText}</span>
      <span>{isHidden ? '' : revealedText}</span>
      {(showReadLess || isHidden) && (
        <button
          className={styles.button}
          onClick={() => setIsHidden(!isHidden)}
        >
          {isHidden ? t`read more` : t`read less`}
        </button>
      )}
    </p>
  )
}
